@let freightData = freight();
@let hideCols = hideColumns();
@if (freightData.id !== undefined && freightData.id !== '' && freightData.stopsBasic.length > 0) {
  <ion-card
    button="true"
    [routerLink]="[`/tabs/${AppTab.FINISHED}`, freightData.id]"
    routerDirection="root"
    routerLinkActive="active"
    class="freight-finished"
    [class.freight-finished--notice]="
      freightData.hasPendingDoc ||
      (freightData.deliveryNoteInPaperRequired &&
        !freightData.deliveryNoteInPaperReceived &&
        freightData.status !== EFreightStatus.CANCELLED)
    "
    [class.freight-finished--in-dashboard]="hideCols"
    [class.freight-finished--cancelled]="freightData.status === EFreightStatus.CANCELLED"
  >
    <ion-card-content>
      <ion-row>
        <ion-col
          size="12"
          [sizeLg]="sizeLgReference()"
          class="ion-no-padding"
        >
          <div class="reference">
            <div>
              <ion-icon
                aria-hidden="true"
                src="../assets/material-symbols/barcode_24dp.svg"
              ></ion-icon>
              <p>
                <strong>{{ freightData.reference }}</strong>
              </p>
            </div>
            <div>
              <ion-icon
                aria-hidden="true"
                src="../assets/material-symbols/pin_drop_24dp.svg"
              ></ion-icon>
              <p>
                <strong>{{ freightData.numberOfStops }}</strong>
              </p>
            </div>
            @if (freightData.hasPendingDoc) {
              <div class="notice">
                <p>
                  {{ 'freight.general.documentation' | translate }}
                </p>
                <ion-icon
                  slot="start"
                  aria-hidden="true"
                  src="../assets/material-symbols/notification_important_24dp.svg"
                ></ion-icon>
              </div>
            }
            @if (freightData.status === EFreightStatus.CANCELLED) {
              <div class="cancelled-tag">
                <span>
                  {{ 'general.cancelled' | translate }}
                </span>
              </div>
            }
          </div>
        </ion-col>

        <ion-col
          size="6"
          [sizeLg]="sizeLgStep()"
        >
          <div class="step step--to-upload">
            <ion-icon
              slot="start"
              aria-hidden="true"
              src="../assets/material-symbols/upload_24dp.svg"
            ></ion-icon>
            <div class="">
              <strong
                >({{ freightData.stopsBasic[0].address.countryCode }})
                {{
                  `states.${freightData.stopsBasic[0].address.countryCode}${freightData.stopsBasic[0].address.stateCode}`
                    | translate
                }}</strong
              >
            </div>
          </div>
          <div class="address">
            <div>
              <p class="company">
                {{ freightData.stopsBasic[0].address.company }}
              </p>
              <p class="city">
                {{ freightData.stopsBasic[0].address.postalCode }} {{ freightData.stopsBasic[0].address.city }}
              </p>
            </div>
            <p class="date">
              {{ freightData.stopsBasic[0].since | dfnsFormat: 'ccc Pp' }}
            </p>
          </div>
        </ion-col>

        <ion-col
          size="6"
          [sizeLg]="sizeLgStep()"
        >
          <div class="step step--to-download">
            <ion-icon
              slot="start"
              aria-hidden="true"
              src="../assets/material-symbols/download_24dp.svg"
            ></ion-icon>
            <div class="">
              <strong>
                ({{ freightData.stopsBasic[freightData.stopsBasic.length - 1].address.countryCode }})
                {{
                  `states.${freightData.stopsBasic[freightData.stopsBasic.length - 1].address.countryCode}${freightData.stopsBasic[freightData.stopsBasic.length - 1].address.stateCode}`
                    | translate
                }}
              </strong>
            </div>
          </div>
          <div class="address">
            <div>
              <p class="company">
                {{ freightData.stopsBasic[freightData.stopsBasic.length - 1].address.company }}
              </p>
              <p class="city">
                {{ freightData.stopsBasic[freightData.stopsBasic.length - 1].address.postalCode }}
                {{ freightData.stopsBasic[freightData.stopsBasic.length - 1].address.city }}
              </p>
            </div>
            <p class="date">
              {{ freightData.stopsBasic[freightData.stopsBasic.length - 1].since | dfnsFormat: 'ccc Pp' }}
            </p>
          </div>
        </ion-col>

        @if (!hideCols) {
          <ion-col
            size-lg="2"
            class="hide-mobile"
          >
            @if (canViewDrivers() && freightData.drivers && freightData.drivers.length > 0) {
              <p class="fs-xs">
                <span class="extra-info-badge">
                  <ion-icon
                    slot="start"
                    aria-hidden="true"
                    src="../assets/material-symbols/id_card_24dp.svg"
                  ></ion-icon>
                  {{ printDrivers(freightData.drivers) }}
                </span>
              </p>
            }
            @if (freightData.vehicles && freightData.vehicles.length > 0) {
              <p class="fs-xs">
                <span class="extra-info-badge">
                  <ion-icon
                    slot="start"
                    aria-hidden="true"
                    src="../assets/material-symbols/local_shipping_24dp.svg"
                  ></ion-icon>
                  {{ printVehicles(freightData.vehicles) }}
                </span>
              </p>
            }
            @if (canViewPrices() && freightData.price) {
              <p class="fs-xs">
                <span class="extra-info-badge">
                  <ion-icon
                    slot="start"
                    aria-hidden="true"
                    src="../assets/material-symbols/payments_24dp.svg"
                  ></ion-icon>
                  {{ freightData.price | number: '1.2-2' }} €
                </span>
              </p>

              @if (freightData.billingStatus === EInvoiceStatus.READY_TO_INVOICE) {
                @if (
                  freightData.fastPaymentForCarrierStatus !== EFastPaymentForCarrierStatus.UNAVAILABLE &&
                  freightData.fastPaymentForCarrierStatus !== EFastPaymentForCarrierStatus.AVAILABLE
                ) {
                  <p class="fs-xs">
                    <span
                      class="extra-info-badge"
                      [class.success]="
                        freightData.fastPaymentForCarrierStatus === EFastPaymentForCarrierStatus.APPROVED ||
                        freightData.fastPaymentForCarrierStatus === EFastPaymentForCarrierStatus.REQUESTED
                      "
                      [class.danger]="freightData.fastPaymentForCarrierStatus === EFastPaymentForCarrierStatus.REJECTED"
                    >
                      <ion-icon
                        slot="start"
                        aria-hidden="true"
                        src="../assets/material-symbols/okc_fast_payment_24dp.svg"
                      ></ion-icon>
                      {{ 'EFastPaymentForCarrierStatus.' + freightData.fastPaymentForCarrierStatus | translate }}
                    </span>
                  </p>
                }
              } @else if (freightData.billingStatus !== EInvoiceStatus.NON_BILLABLE) {
                <p class="fs-xs">
                  <span
                    class="extra-info-badge"
                    [class.success]="
                      freightData.billingStatus === EInvoiceStatus.INVOICED ||
                      freightData.billingStatus === EInvoiceStatus.PAID
                    "
                    [class.danger]="freightData.billingStatus === EInvoiceStatus.OVERDUE"
                  >
                    <ion-icon
                      slot="start"
                      aria-hidden="true"
                      src="../assets/material-symbols/okc_invoice_24dp.svg"
                    ></ion-icon>
                    {{ 'EInvoiceStatus.' + freightData.billingStatus | translate }}
                  </span>
                </p>
              }
            }
          </ion-col>
        }
      </ion-row>

      @if (freightData.hasPendingDoc && !hideCols) {
        <div class="notice-more">
          <p>
            {{ 'freight.general.missing_dn' | translate }}
          </p>
        </div>
      }

      @if (
        freightData.deliveryNoteInPaperRequired &&
        !freightData.deliveryNoteInPaperReceived &&
        freightData.status !== EFreightStatus.CANCELLED &&
        !hideCols
      ) {
        <div class="notice-more">
          <p>
            {{ 'freight.general.missing_paper' | translate }}
          </p>
        </div>
      }
    </ion-card-content>
  </ion-card>
}
